// Convert whole price to decimal (e.g. 1499 --> 14.99)
export const insertDecimal = (num: number) => {
  return (num / 100).toFixed(2);
};

export const wholePriceToFloat = (price: number) => {
  return parseFloat(insertDecimal(price));
};
